import { useContext } from "react";
import NoteGridPanel from "../../../common/notes/components/NoteGridPanel";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function RetailOrderNotesPanel(props: { height?: string | number }) {

	const { order } = useContext(RetailOrderContext);

	return (
		<NoteGridPanel
			notes={order.details.notes}
			height={props.height}
		/>
	)
}
